import api from "@/api/api-v1-config";

export async function getChartOfAccountAxios() {    
    return await api.get("v1/chartofaccounts/chartofaccount");
}

export async function getChartOfAccountIDAxios(id) {    
    return await api.get("v1/chartofaccounts"+ id);
}

export async function deleteChartOfAccountAxios(id) {    
    return await api.delete("v1/chartofaccounts?Id=" + id);
}

export async function postChartOfAccountAxios(ChartOfAccount) {    
    return await api.post("v1/chartofaccounts/chartofaccount", ChartOfAccount);
}

export async function putChartOfAccountAxios(ChartOfAccount) {    
    return await api.put("v1/chartofaccounts/", ChartOfAccount);
}

